export function engagement() {

    const nextButton = document.querySelector("div#prequal a#next");
    const range = document.querySelector("div#prequal input#how_much");
    const selects = document.querySelectorAll("fieldset select");
    const income = document.querySelector("#income");
    const housing = document.querySelector("#housing");
    const formatter = new Intl.NumberFormat('en-US');
    let formStep = 0;
    let rangeTicks = [];
    document.querySelectorAll("#borrow_choices option").forEach(o => {
        rangeTicks.push(o.value);
    });

    if(range != null){
        if ("oninput" in range) {
            range.addEventListener("input", function(e) {
                barColor(this);
            }, false);
        }

        range.addEventListener("change", function(e){
            rangeTicks.forEach((v, i) => {
                if(e.target.value <= parseFloat(v) && !rangeTicks.includes(e.target.value)) {
                    e.target.value = (i > 0) ? ((parseFloat(v)-e.target.value) < (parseFloat(v)-parseFloat(rangeTicks[i-1]))/2) ? v : rangeTicks[i-1] : v;
                }
            });
            barColor(this);
        });
    
        function barColor(sliderElement){
            let value = (sliderElement.value-sliderElement.min)/(sliderElement.max-sliderElement.min)*100;
            sliderElement.style.background = 'linear-gradient(to right, var(--green-300) 0%, var(--green-300) ' + value + '%, #d3d3d3 ' + value + '%, #d3d3d3 100%)';
            document.querySelector("#how_much_value").textContent = "$" + formatter.format(sliderElement.value);
        }
    }

    if(document.querySelector("div#prequal div.controls") != null){
        nextButton.addEventListener("click", showNextStep );
        selects.forEach( (e) => {
            e.addEventListener("change", showNextStep);
        });
        income.addEventListener("keyup", function(e){
            this.value = "$" + formatter.format(this.value.replace(/[^0-9]/g, ''));
            if(this.value != "$" && this.value != "" && formStep == 3){
                nextButton.style.display = "inline-block";
            }
        });
        housing.addEventListener("keyup", function(e){
            this.value = "$" + formatter.format(this.value.replace(/[^0-9]/g, ''));
            if(this.value != "$" && this.value != "" && formStep == 4){
                nextButton.style.display = "inline-block";
            }
        });
    }

    function showNextStep(e){
        e.preventDefault();
        if(this.value == ""){
            return;
        }
        var options = this.querySelectorAll('option[value=""]');
        options.forEach( (el) => {
            el.remove();
        });

        if((this.nodeName == "SELECT" && (formStep <= this.dataset.step)) || this.nodeName == "A"){
            formStep++;
        }else{
            return;
        }

        if(formStep > 0){
            nextButton.style.display = "none";
        }
        if(this.id == "credit_score"){
            nextButton.textContent = ((document.documentElement.lang === 'en-US') ? "Get loan example" : "Ve el ejemplo de un préstamo");
            nextButton.style.display = "inline-block";
        }else if(formStep > 5 && this.id == nextButton.id){
            const children = document.querySelectorAll(".pop-up-content > *");
            children.forEach( (el) => {
                el.style.display = "none";
            });
            updateLoanDetails();
            document.querySelector("#loan_details").style.display = "block";
        }else{
            document.querySelector("#step" + formStep).style.display = "flex";
        }
    }

    function updateLoanDetails(){
        const amount = document.querySelector("h2.amount em");
        const length = document.querySelector("div.terms div.length div.value");
        const payment = document.querySelector("div.terms div.payment div.value");
        const months = ((document.documentElement.lang === 'en-US') ? "months" : "meses");
        switch(document.querySelector("#credit_score").value){
            case "Excellent (700+)":
                amount.textContent = "$5,100 - $10,000";
                length.textContent = "30 - 45 " + months;
                payment.textContent = "$119 - $188";
                break;
            case "Good (660-699)":
                amount.textContent = "$1,600 - $6,000";
                length.textContent = "15 - 33 " + months;
                payment.textContent = "$62 - $133";
                break;
            case "Average (580-659)":
                amount.textContent = "$1,000 - $5,000";
                length.textContent = "12 - 30 " + months;
                payment.textContent = "$46 - $117";
                break;
            case "Low (Under 580)":
                default:
                amount.textContent = "$600 - $3,100";
                length.textContent = "12 - 27 " + months;
                payment.textContent = "$28 - $78";
                break;
        }
    }
}